import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import userRouter from './modules/router'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    userRouter
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js